import styled, { css } from 'styled-components'
import { TooltipProps } from '@elamajs/ui-kit'

export const Container = styled.div<{ isNewGrid: boolean }>`
  margin-top: 3.5rem;
  width: 245px;
  display: grid;
  row-gap: 30px;
  column-gap: 80px;
  grid-template-rows: repeat(4, max-content);
  height: fit-content;

  ${({ isNewGrid }) =>
    isNewGrid &&
    css`
      row-gap: 20px;
    `};

  @media (max-width: 1279px) {
    margin-top: 0;
    flex: 1;
    width: unset;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, max-content);

    padding: 40px 70px 40px 90px;
    border-radius: 10px;
    background-color: ${({ theme }) => theme.palette.white};

    & > div:nth-child(1) {
      order: 1;
    }
    & > div:nth-child(2) {
      order: 3;
    }
    & > div:nth-child(3) {
      order: 4;
    }
    & > div:nth-child(4) {
      order: 2;
    }

    ${({ isNewGrid }) =>
      isNewGrid &&
      css`
        grid-template-rows: repeat(2, 1fr);
        padding: 4rem;

        & > div:nth-child(1) {
          order: 1;
          width: 29rem;
        }
        & > div:nth-child(2) {
          order: 3;
          grid-column: span 2 / span 2;
        }
        & > div:nth-child(3) {
          order: 2;
          width: 29rem;
          margin-left: -5rem;
        }
      `};
  }

  @media (max-width: 999px) {
    padding: 40px 30px;
    column-gap: 28px;

    ${({ isNewGrid }) =>
      isNewGrid &&
      css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 48px;

        & > div:nth-child(3) {
          margin-left: 0;
        }
      `};
  }

  @media (max-width: 767px) {
    padding: 40px 20px;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, max-content);

    & > div {
      order: initial !important;
    }

    ${({ isNewGrid }) =>
      isNewGrid &&
      css`
        & > div:nth-child(1),
        & > div:nth-child(2),
        & > div:nth-child(3) {
          width: 100%;
        }
      `};
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
`

export const Label = styled.div`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
`

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
`

export const Checkbox = styled.div`
  div[class^='Checkboxstyled__CheckboxContent'] {
    color: ${({ theme }) => theme.palette.black[20]};
    font-size: 14px;
  }

  div[class^='Checkboxstyled__Label'] {
    word-break: unset;
  }
`

export const Tooltip = styled.div<TooltipProps>`
  color: #292e3d;

  ~ div {
    z-index: 2;

    & > div {
      display: flex;
      flex-direction: column;
      row-gap: 20px;

      font-size: 12px;
      line-height: 18px;
      font-weight: 400;

      color: ${({ theme }) => theme.palette.black[50]};
    }
  }
`

export const Link = styled.a`
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;

  color: ${({ theme }) => theme.palette.black[60]};
`
